import React, { Component} from 'react';
import { FacebookProvider, Page, Comments, ShareButton  } from 'react-facebook';
 
export default class Facebook extends Component {
  render() {
    return (
      <FacebookProvider appId="422330008653717"  >
        <Page href="https://www.facebook.com/promperu" tabs="timeline"  width="600" height="1560" />
        <Comments href="http://www.facebook.com/promperu" />
      </FacebookProvider>    
    );
  }
}
  //137541772984354